import { Badge } from "@chakra-ui/react";
import { ScreeningStatus, statusLabels } from "../mappers/screening.mapper";

const statusColors: Record<ScreeningStatus, { bg: string; color: string }> = {
  pending: { bg: "#FFF7D6", color: "#E6AE22" },
  preApproved: { bg: "#E8F1FF", color: "#4A7DD8" },
  inReview: { bg: "#EDEBFF", color: "#7B61FA" },
  approved: { bg: "#E3FFE4", color: "#3CB18B" },
  rejected: { bg: "#FFDCDC", color: "#EC5858" },
  contracted: { bg: "#DFEAFF", color: "#6887D8" },
};

type Props = { status: ScreeningStatus };

const StatusBadge = ({ status }: Props): JSX.Element => (
  <Badge
    bg={statusColors[status].bg}
    color={statusColors[status].color}
    size="md"
  >
    {statusLabels[status]}
  </Badge>
);

export default StatusBadge;
